import axiosInstance from '../app/axios';

export const orderAPI = {
  create: async (orderData) => {
    const response = await axiosInstance.post('/orders', orderData);
    return response.data;
  },
  cancel: async (orderId) => {
    const response = await axiosInstance.patch(`/orders/${orderId}/cancel`);
    return response.data;
  },
};

export default orderAPI;
